export default __webpack_public_path__ + "static/media/AM_00782 copy.303c8602.jpg";